import {Box} from '@sanity/ui'
import {memo} from 'react'
import {styled} from 'styled-components'

export const SearchWrapper = memo(styled(Box)`
  background-color: var(--card-bg-color);
`)
